import React from "react";
import "./footer.css";
import logo from "../../media/images/logo.png";
import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <footer>
            <div>
                <div>
                    <Link
                        aria-label="To accessibility statement"
                        to="/accessibility-statement"
                    >
                        הצהרת נגישות
                        <i className="bi bi-universal-access"></i>
                    </Link>
                    <hr />
                    <h2>כל הזכויות שמורות&copy;</h2>
                </div>
                <img src={logo} alt="Logo" />
            </div>
            <div>
                <a href="https://www.daniel-allali.com/">
                    האתר עוצב ונבנה על ידי דניאל אלאלי
                </a>
            </div>
        </footer>
    );
};

export default Footer;
